import React from 'react';
import { FadeLoader } from 'react-spinners';
import ReactPaginate from 'react-paginate';
import formatMoney from '../../../utils/formatMoney';

const renderTable = ({ listConsultaProforma }, selectedProform, selectProform,fichaVentaDeProformaQueYaSeAsigno ) => {
  if (listConsultaProforma.length) {
    return listConsultaProforma.map((proforma, index) => (
      <tr key={index}>
        <td>
          <div className='checkbox checkbox-inline'>
            <label>
              <input type='checkbox' checked={selectedProform.filter(({ nroProforma }) => nroProforma === proforma.nroProforma).length} />
              <div className='checkbox-skin' onClick={() => selectProform(proforma)} />
            </label>
          </div>
        </td>
        <td>{proforma.nroProforma}</td>
        <td>{proforma.familia}</td>
        <td>{proforma.marca}</td>
        <td>{proforma.desBaumuster}</td>
        <td>{proforma.cantidad}</td>
        <td style={{ display: 'flex', justifyContent: 'space-between' }}>
        {proforma.moneda === 'Dólares' ? 'US$' : 'S/'}{/*Req. 92293 ebarboza 26 07 2021 */}<span>{formatMoney(proforma.precioTotal)}</span>
        </td>
      </tr>
    ));
  }
  return <tr><td className='no-before' colSpan={7}>No hay resultados</td></tr>;
};

const TablaProforma = props => (
  <div>
    <div className='tableWrapper hide-scroll'>
      <table className='table table-hover'>
        <thead className='table-head'>
          <tr>
            <th />
            <th>N° Proforma</th>
            <th>Familia</th>
            <th>Marca</th>
            <th>Modelo</th>
            <th>Cant.Unid</th>
            <th>Valor Total</th>
          </tr>
        </thead>
        <tbody>
          {
            props.proformas
             ? renderTable(props.proformas, props.selectedProform, props.selectProform, props.fichaVentaDeProformaQueYaSeAsigno)
             : <tr><td className='no-before' colSpan={7}><FadeLoader color={'#F8A14A'} loading /></td></tr>
          }
        </tbody>
      </table>

    </div>
    {
      props.proformas &&
      <div className={props.proformas.numerodePaginas > 1 ? 'paginationWrapper' : 'hidden'}>
        <div className='row' style={{ marginTop: '20px' }}>
          <div className='col-sm-6 pull-right'>
            <ReactPaginate
              pageCount={props.proformas.numerodePaginas}
              onPageChange={props.paginateProform}
              previousLabel='<<'
              nextLabel='>>'
              containerClassName='pagination pull-right'
              pageClassName='pagination-item'
              activeClassName='pagination-item--active'
              pageLinkClassName='btn-clean pagination-item-btn'
              breakClassName='break pagination-item'
            />
          </div>
        </div>
      </div>
    }

    {
        props.fichaVentaDeProformaQueYaSeAsigno !== '' ?(
          <div className='row' style={{ marginLeft: '20px' }}>
            <div className=''>
              <div className='row' style={{ marginTop: '20px' }}>{ props.fichaVentaDeProformaQueYaSeAsigno + '   '}     <a onClick={() => props.searchFDV(1,props.nroProforma)} > Ir Ficha de Venta </a></div>
            </div>
          </div>
        ):null

    }


  </div>
);

export default TablaProforma;



// WEBPACK FOOTER //
// ./src/pages/modals/NuevaFichaVenta/TablaProforma.js